import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { useRevealOnScroll } from "../../hooks/useRevealOnScroll";
import SectionIntro from "../../components/SectionIntro/SectionIntro";
import { partners } from "../../data/partnersData";

const PartnersSection = () => {
  const { t } = useTranslation();
  const revealRef = useRevealOnScroll({ threshold: 0.06 });

  return (
    <section
      className="section-n section--partners section--en vh-partners"
      aria-labelledby="partners-heading"
    >
      <div ref={revealRef} className="container-n reveal">
        <div className="vh-partners__inner pr-big">
          <a className="skip-the-section link-n" href="#contact-us">
            <span className="link-n__text">{t("skip.section")}</span>
          </a>

          <header className="vh-partners__header">
            <SectionIntro
              eyebrow={t("partners.eyebrow")}
              className="vh-partners__intro"
            >
              <h2
                id="partners-heading"
                className="section__title title-h2 vh-partners__title"
              >
                {t("partners.title")}
              </h2>
            </SectionIntro>
          </header>

          <ul className="vh-partners__grid">
            {partners.map((partner) => (
              <li key={partner.id} className="vh-partners__cell">
                {partner.logo ? (
                  <img
                    src={partner.logo}
                    alt={t(partner.nameKey)}
                    className="vh-partners__logo img-fluid"
                  />
                ) : (
                  <span className="vh-partners__placeholder" aria-hidden="true">
                    {t("partners.logoPlaceholder")}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default memo(PartnersSection);
